//@flow
import * as Immutable from 'immutable';

import {
    TaskProfile,
    ParserSettings,
    UserHeader
} from 'common/models/flow/TaskProfile';
import type {
    TaskProfileModelType,
    ParserSettingsModelType,
    UserHeaderModelType
} from 'common/models/flow/TaskProfile';

class InternalTaskProfile extends TaskProfile {
    static fromJS(json: TaskProfileModelType): InternalTaskProfile {
        const state: Object = Object.assign({}, json);
        state.csvParserSettings = InternalParserSettings.fromJS(
            state.csvParserSettings
        );
        return new this(Immutable.Map(state));
    }

    get csvParserSettings(): InternalParserSettings {
        return this._state.get('csvParserSettings');
    }

    getVisitType(): ?string {
        return this.csvParserSettings.useCase === 'SERVICE'
            ? this.csvParserSettings.useCase
            : null;
    }
}

class InternalParserSettings extends ParserSettings {
    static fromJS(json: ParserSettingsModelType): InternalParserSettings {
        const state: Object = Object.assign({}, json);
        state.userHeaders = Immutable.Map(state.userHeaders).map(item =>
            InternalUserHeader.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalUserHeader extends UserHeader {
    static fromJS(json: UserHeaderModelType): InternalUserHeader {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalTaskProfile as TaskProfile,
    InternalParserSettings as ParserSettings,
    InternalUserHeader as UserHeader
};
